import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { ConstructionService } from './api/construction.service';
import { EquipmentService } from './api/equipment.service';
import { NotificationsService } from './api/notifications.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class EquipmentApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<EquipmentApiModule> {
        return {
            ngModule: EquipmentApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: EquipmentApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('EquipmentApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
